import { BoilerAdapter, get_z3k_object_state, HeatingCircuit, } from 'z3k-config';
import { createSelector } from 'reselect';
import { boilerAdaptersSelector } from 'z3k-parser/lib/z3k-selectors';
import { select_z3k_boiler_adapters } from 'shared/components/banners/failure/selectors';
import { selectSelectedDeviceFields } from 'entities/device/lib';
import { partial } from 'webui/utils/functions';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
export const selectDeviceForExternalPanel = createSelector(selectSelectedDeviceFields([
    'id',
    'capabilities',
    'online',
]), (dev) => (dev != null ? dev : null));
export const selectedDeviceWithZ3kConfigAndState = createSelector(selectSelectedDeviceFields(['z3k_config', 'z3k_state']), (dev) => (dev != null ? dev : null));
export const selectDeviceForMasterSetting = createSelector(selectSelectedDeviceFields(['id', 'z3k_config', 'is_configured_by_wizard', 'hardware_type', 'device_type']), (dev) => (dev != null ? dev : null));
export const selectTempStep = createSelector(selectSelectedDeviceFields(['tempstep']), (dev) => (dev != null ? dev.tempstep ?? 1 : undefined));
export const selectZ3kConfig = createSelector(selectSelectedDeviceFields(['z3k_config']), (dev) => (dev != null ? dev.z3k_config : undefined));
export const selectZ3kState = createSelector(selectSelectedDeviceFields(['z3k_state']), (dev) => (dev != null ? dev.z3k_state : undefined));
export const selectHeatingCircuits = createSelector(selectZ3kConfig, (config) => HeatingCircuit.get.where(config, (hc) => !HeatingCircuit.isHidden(hc) && !HeatingCircuit.isBoiler(hc)));
export const selectHCWithBa = createSelector(selectZ3kConfig, (config) => {
    const boiler_adapter_ids = boilerAdaptersSelector(config ?? {});
    return HeatingCircuit.get.one(config, (hc) => HeatingCircuit.isCircuitWithBoilerAdapter(boiler_adapter_ids, hc));
});
export const selectHeatingModes = createSelector(selectZ3kConfig, HeatingMode.get.all);
export const selectSelectedModes = createSelector(selectHeatingCircuits, selectZ3kConfig, selectZ3kState, (hcs, config, state) => HeatingMode.get.where(config, (hm) => hcs.some(({ id }) => get_z3k_object_state(state, id)?.mode_id === hm.id)));
export const selectBoilerAdaptersWithExtPanel = createSelector(selectZ3kConfig, (config) => BoilerAdapter.get.one(config, BoilerAdapter.isExternalPanel));
export const selectTurnOnExtPanel = createSelector(selectBoilerAdaptersWithExtPanel, selectZ3kState, BoilerAdapter.isTurnOnExtPanel);
export const selectBoilerAdaptersForShowFail = createSelector(selectSelectedDeviceFields(['z3k_config', 'z3k_state']), (dev) => (dev != null ? select_z3k_boiler_adapters(dev) : []));
/**
 * @function
 * Есть ли ошибка в котловых контурах
 * 1.Находим все котловые контура
 * 2.Находим их состояние и если стоит флаг CIRCUIT_SENSOR_FAULT_FLAG
 * то делаем вывод, что ошибка
 * @param config - Z3k-конфиг
 * @param state - Z3k-состояние
 * @return boolean
 */
export const selectFailInBoilers = createSelector(selectZ3kConfig, selectZ3kState, (config, state) => {
    if (config == null || state == null) {
        return false;
    }
    const boiler_adapter_ids = boilerAdaptersSelector(config ?? {});
    return HeatingCircuit.get
        .where(config, partial(HeatingCircuit.isCircuitWithBoilerAdapter, boiler_adapter_ids))
        .some((hc) => {
        const hc_state = get_z3k_object_state(state, hc.id);
        return hc_state != null ? HeatingCircuit.isFail(hc_state) : false;
    });
});
